import { mapState, mapMutations } from 'vuex'
export const getQuery = {
  data () {
    return {
      queryDataObj: {}
    }
  },
  methods: {
    ...mapState({
      multipage: state => state.queryCriteria.queryList
    }),
    ...mapMutations({
      setQueryList: 'queryCriteria/setQueryList'
    }),
    radioGroupChange (e, r, v, n) {
      if (n && n === 'number') {
        this.$set(this.queryDataObj, r, Number(e.target.value))
      } else {
        this.$set(this.queryDataObj, r, e.target.value)
      }
      this.setQueryList({ [v]: this.character })
      this.pagination.current = 1
      this.initData(this.character)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getQuery.js